import script from "./LowCarbon.vue?vue&type=script&lang=ts&setup=true"
export * from "./LowCarbon.vue?vue&type=script&lang=ts&setup=true"

import "./LowCarbon.vue?vue&type=style&index=0&id=2a9d3e5b&lang=scss&scoped=true"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9d3e5b"]])

export default __exports__